export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">关于本站</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              51cg网址导航致力于为读者提供最新、最全的51cg官方域名入口与平台介绍，帮助大家快速找到可用的51cg官方网站，了解平台动态与访问方式。
            </p>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '专题索引', href: '#index' },
                { label: '动态快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">暂无合作伙伴信息</p>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">免责声明</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              本站仅为网址导航与信息整合平台，所有内容来源于公开信息，仅供参考。如涉及版权或其他问题，请通过联系方式与我们沟通。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 51cg 网址导航 — 本站为非官方信息聚合平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}